import { AccredibleObjectWithId } from '@accredible-frontend-v2/models';
import { ButtonSize } from '@accredible-frontend-v2/new-components/button';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'accredible-multi-search-filter-menu',
  templateUrl: './multi-search-filter-menu.component.html',
  styleUrls: [`./multi-search-filter-menu.component.scss`],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccredibleMultiSearchFilterMenuComponent {
  @Input()
  buttonText: string;
  @Input()
  dataCy = 'multi-search-menu';
  @Input()
  buttonSize: ButtonSize = 'small';
  @Input()
  placeholder = '';
  @Input()
  options: AccredibleObjectWithId[];
  @Input()
  optionsLabelKey: string;
  @Input()
  optionsImgKey: string;
  @Input()
  selectedOptions: AccredibleObjectWithId[] = [];
  @Input()
  usingStaticOptions = false;
  @Input()
  useEllipsisOnOptions = true;
  @Input()
  menuWidthEqualsButtonWidth = false;
  @Input()
  hideSearchInput = false;
  @Input()
  disabled = false;
  @Input()
  maxSelect = Number.MAX_SAFE_INTEGER;

  @Output()
  optionsChanged = new EventEmitter<any[]>();
  @Output()
  searchChanged = new EventEmitter<string>();
  @Output()
  menuToggle = new EventEmitter<boolean>();

  menuOpened = false;

  onMenuToggle(menuOpened: boolean): void {
    this.menuOpened = menuOpened;
    this.menuToggle.emit(menuOpened);
  }
}
